var _path, _path2, _ellipse, _ellipse2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwardRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 45,
    viewBox: "0 0 32 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1297 27.6533L17.314 31.4941L25.1841 44.7993L25.219 44.7796L26.4839 39.315L31.9649 40.9781L31.9998 40.9584L24.1297 27.6533Z",
    fill: "#6366F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2601 31.4952L9.44434 27.6543L1.57421 40.9594L1.60916 40.9791L7.09014 39.316L8.35499 44.7806L8.38994 44.8003L16.2601 31.4952Z",
    fill: "#6366F1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.7403,
    cy: 15.3634,
    rx: 15.7403,
    ry: 15.3634,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.7402,
    cy: 15.363,
    rx: 12.5922,
    ry: 12.2908,
    fill: "#6366F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7402 6.57812L17.7609 12.6481H24.2997L19.0097 16.3995L21.0303 22.4695L15.7402 18.7181L10.4502 22.4695L12.4708 16.3995L7.18073 12.6481H13.7196L15.7402 6.57812Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardRibbon);
export default __webpack_public_path__ + "static/media/award-ribbon.699e88224460fb4c4326be9c22e2f986.svg";
export { ForwardRef as ReactComponent };